import { splunk } from '@fs/zion-splunk-logger'
import { getCorrelationId } from '@fs/zion-session'

export default async ({ start, stop, request, status, setResponseTime = () => {}, task }) => {
  const correlationId = getCorrelationId()
  const responseTime = Math.abs(stop - start)
  setResponseTime(responseTime)
  const logObject = { correlationId, request: { elapsed: responseTime, ...request, status, task } }
  splunk.log(logObject)
}
